import PropTypes from "prop-types";
import React from "react";
import { Modal, Spinner } from "react-bootstrap";

const PopupModalWithOk = ({
  show,
  onHide,
  message = "Action completed successfully.",
  title = "",
  loading = false,
  onConfirm,
  showConfirm = false,
  confirmText = "Ok",
  staticBackdrop = false,
}) => {
  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      backdrop={staticBackdrop ? "static" : true}
      keyboard={!staticBackdrop}
      className="dialog_box text-center"
    >
      {title && (
        <Modal.Header closeButton={!staticBackdrop}>
          <Modal.Title className="w-100 text-center">{title}</Modal.Title>
        </Modal.Header>
      )}

      <Modal.Body>
        {loading ? (
          <Spinner animation="border" role="status" className="my-3">
            <span className="visually-hidden">Loading...</span>
          </Spinner>
        ) : (
          <p className="text-gray-800 mb-0">{message}</p>
        )}
      </Modal.Body>

      <Modal.Footer className="justify-content-center px-0 py-0">
        {showConfirm ? (
          <button
            // variant="primary"
            onClick={onConfirm || onHide}
            className="px-5 py-3 rounded-1 fs-4 w-100 m-0 btn btn_red"
          >
            {confirmText}
          </button>
        ) : (
          <button
            // variant="primary"
            onClick={onHide}
            className="px-5 py-3 rounded-1 fs-4 w-100 m-0 btn btn_red"
          >
            Ok
          </button>
        )}
      </Modal.Footer>
    </Modal>
  );
};

PopupModalWithOk.propTypes = {
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
  message: PropTypes.string,
  title: PropTypes.string,
  loading: PropTypes.bool,
  onConfirm: PropTypes.func,
  showConfirm: PropTypes.bool,
  confirmText: PropTypes.string,
  staticBackdrop: PropTypes.bool,
};

export default PopupModalWithOk;
